import { Fetch, schemas } from '@convergence/client';
import { useQuery } from '@tanstack/react-query';

const tinkerBoxQueryMode = {
  personal: 'personal',
  lab: 'lab'
} as const;
export type TinkerBoxQueryMode =
  typeof tinkerBoxQueryMode[keyof typeof tinkerBoxQueryMode];

export async function getLabTinkerBoxes(
  fetch: Fetch,
  labId: number | undefined | null
) {
  if (!labId) {
    const response = await fetch(
      `/tinker-boxes/?personal=true`,
      { method: 'GET' },
      schemas.GetTinkerBoxesResponse
    );
    return response;
  } else {
    const response = await fetch(
      `/tinker-boxes/?lab=${labId}`,
      { method: 'GET' },
      schemas.GetTinkerBoxesResponse
    );
    response.tinkerboxes[0]!.status;
    return response;
  }
}

export const useTinkerBoxesQuery = (
  fetch: Fetch,
  isLab: boolean,
  labId: number | undefined | null
) => {
  return useQuery({
    queryKey: ['tinkerboxes', labId],
    refetchInterval: 5000,
    networkMode: 'always',
    retry: false,
    enabled: isLab ? labId !== undefined : true,
    queryFn: async () => {
      if (isLab && !labId) {
        return { tinkerboxes: [] };
      }
      const tinkerboxes = await getLabTinkerBoxes(fetch, labId);
      return tinkerboxes;
    }
  });
};
